import { ChecklistItemStatus } from '../../types/checklist_types';
import { ChecklistItemsByFilterQuery } from '../../queries/checklist_items_by_filter_query';
import { ChecklistItemQuery } from '../../queries/checklist_item_query';
import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IChecklistFilterStrategy } from '../../strategies/checklist_filter_strategy';

class ChecklistDashboardController {
  private selectedFilterStrategy: ChecklistItemStatus;

  constructor(
    private ngChecklistItemQuery: ChecklistItemQuery,
    private ngChecklistItemsByFilterQuery: ChecklistItemsByFilterQuery,
    private selectChecklistItemCommand: ICommand,
    private filterChecklistItemsCommand: ICommand,
    private ngChecklistFilterStrategy: IChecklistFilterStrategy,
    private $state: ng.ui.IStateService
  ) {
    this.filterChecklistItemsCommand(this.ngChecklistFilterStrategy[$state.params['filter']]).then(() => {
      this.selectFirstItemDetail();
      this.selectedFilterStrategy = this.$state.params['filter'];
    });
  }

  selectFirstItemDetail(): void {
    if (!this.isChecklistItemsListEmpty() && !this.getSelectedItem()) {
      this.selectChecklistItemCommand(_.first(this.ngChecklistItemQuery.result.list));
    }
  }

  filter_onValueChanged($event: CustomEvent) {
    return this.filterAlgorithmOnChange($event.detail.value);
  }

  filterAlgorithmOnChange(key: string) {
    const stateParam = _4.get(this.$state, 'params.filter', '');
    const isAlreadyInState = stateParam === key;
    if (isAlreadyInState) {
      return;
    }
    return this.$state.go('my.checklist', { filter: key });
  }

  getSelectedItem() {
    return _.find(this.ngChecklistItemQuery.result.list, (item) => item.isSelected);
  }

  isFilterEnabled(strategyKey: string) {
    return !_.isEmpty(this.ngChecklistItemsByFilterQuery.result.availableFilters[strategyKey]);
  }

  isChecklistItemsListEmpty(): boolean {
    return _.isEmpty(this.ngChecklistItemQuery.result.list);
  }

  shouldShowErrorMessage(): boolean {
    return !this.ngChecklistItemQuery.result.hasAnyChecklistItems;
  }

  shouldShowCompleteMessage(): boolean {
    return this.ngChecklistItemsByFilterQuery.result.areAllItemsCompleted;
  }

  shouldShowNothingCompleteMessage(): boolean {
    return (
      this.isChecklistItemsListEmpty() &&
      this.ngChecklistItemQuery.result.filter === this.ngChecklistFilterStrategy.completed
    );
  }
}

angular.module('capability-ng-checklist').component('checklistDashboard', {
  controller: ChecklistDashboardController,
  controllerAs: '$ctrl',
  templateUrl: 'lib/checklist/components/checklist_dashboard/checklist_dashboard.html'
});



// WEBPACK FOOTER //
// ./app/lib/checklist/components/checklist_dashboard/checklist_dashboard.ts